import React, { useEffect, useState } from "react";
import { SingleService } from "./SingleService";
import Cookies from "js-cookie";
import axios from "axios";
import styled from "@emotion/styled";
import { useGetServicesQuery } from "src/api/servicesApiSlice";

const ServicesContainer = styled.div`
  display: grid;
  grid-template-rows: 250px 250px;
  grid-template-columns: 250px 250px 250px;
  grid-gap: 30px;
`;

const ServiceList = (props) => {
  const { data, isLoading, isSuccess, isError, error } = useGetServicesQuery();
  if (isLoading) {
    return "Loading...";
  }
  if (isError) {
    return `${error.message}`;
  }
  if (isSuccess) {
    return (
      <ServicesContainer>
        {data && data.length > 0
          ? data.map((singleServiceData, idx) => {
              return <SingleService key={idx} data={singleServiceData} />;
            })
          : "No services"}
      </ServicesContainer>
    );
  }
};

export { ServiceList };
